import {css} from '@yandex-delivery/blocks/theme/css'
import {theme} from '@yandex-delivery/blocks/theme/theme'
import checkIcon from 'src/shared/assets/checkIcon.svg'

const CHECKBOX_SIZE = 32

export const classes = {
  root: css`
    cursor: pointer;
    border-bottom: 1px solid #d2d0cc;
    min-height: 48px;
    box-sizing: border-box;
    line-height: ${CHECKBOX_SIZE}px;
    display: block;
    position: relative;
    padding: ${theme.spacing(1)}px ${CHECKBOX_SIZE + theme.spacing(1)}px ${theme.spacing(1)}px 0;
    &::after {
      content: '';
      display: block;
      width: ${CHECKBOX_SIZE}px;
      height: ${CHECKBOX_SIZE}px;
      border-radius: 8px;
      position: absolute;
      background-color: #f1f0ed;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto 0;
      box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.05);
    }
  `,
  selected: css`
    &::after {
      background: url('${checkIcon}') no-repeat center center #fce001;
      box-shadow: unset;
    }
  `,
}
